import React from "react";
import { validEmail } from "../../hooks/utils/useFormat";

export default function InputEmail(props) {
  const { required, value } = props;

  return (
    <input type="email" data-required={required} data-required-valid={required && !!validEmail(value)} {...props} />
  );
}
